import { createContext, useReducer } from 'react';

const initialState = {
  isOpenDialog: false,
  isAutoLoginLoading: false,
  isForceSaveLoading: false,
  onConfirm: () => {},
};
export const SaveOnPodSpaceDialogContex = createContext(initialState);
export const DispatchSaveOnPodSpaceDialogContext = createContext();

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'OPEN_DIALOG':
      return { ...state, isOpenDialog: true };
    case 'CLOSE_DIALOG':
      return { ...state, isOpenDialog: false };
    case 'FORCE_SAVE_STARTED':
      return { ...state, isForceSaveLoading: true };
    case 'FORCE_SAVE_FINISHED':
      return { ...state, isForceSaveLoading: false, isOpenDialog: false };
    case 'AUTO_LOGIN_STARTED':
      return { ...state, isAutoLoginLoading: true };
    case 'AUTO_LOGIN_FINISHED':
      return { ...state, isAutoLoginLoading: false, isOpenDialog: false };
    case 'SET_ON_CONFIRM':
      return { ...state, onConfirm: action.payload };
    default:
      return state || initialState;
  }
};

export function SaveOnPodSpaceDialogProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <SaveOnPodSpaceDialogContex.Provider value={state}>
      <DispatchSaveOnPodSpaceDialogContext.Provider value={dispatch}>
        {children}
      </DispatchSaveOnPodSpaceDialogContext.Provider>
    </SaveOnPodSpaceDialogContex.Provider>
  );
}
